import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FontLoaderComponent, LoadingComponent, MenuService, SideMenuComponent, TopMenuComponent } from 'tms-lib';
import { HelpPanelComponent } from './shared/components/help';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    LoadingComponent,
    FontLoaderComponent,
    TopMenuComponent,
    SideMenuComponent,
    RouterOutlet,
    HelpPanelComponent,
  ],
})
export class AppComponent {
  protected readonly menuService = inject(MenuService);
}
